export default __webpack_public_path__ + "static/media/files.32d22476.svg";